import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
// import resumoMapaColetas from "entity/Indicador/reports/ResumoMapaColetas";
import TableReportHelper from "report/helper";

export default async function baReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const configIndicador = {
            showTrator: false,
            showImplemento: false,
            showFrente: false,
            addHeaderField: [
                {
                    field: "talhao.area",
                    label: "Área do Talhão (ha)",
                    width: 90,
                    valueGetter: (a) => {
                        let sumArea = 0

                        if (a.talhao.length) {
                            for (let i = 0; i < a.talhao.length; i++) {
                                sumArea = sumArea + parseFloat(a.talhao[i].area)
                            }

                            return sumArea.toFixed(2)
                        } else {
                            return a.talhao.area
                        }
                    },
                },
            ]
        }

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                "Resultado",
                configIndicador,
                { label: "Índice", field: "indice", width: 30 }
            ),

            h.panel(
                [
                    h.row(
                        h.title("Variedade"),
                        h.text(apontamento.insumo),
                    ),
                ],
                { widths: [60, "*",] }
            ),

            h.space(),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Armadilha", "Qtd. Mariposas", "Índice"],
                // prettier-ignore
                (h) => [
                    h.textField("armadilha"),
                    h.numberField("qtdMariposas"),
                    h.textField("conforme"),
                ],
                [60, 60, 60]
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            // TODO: show map with all the indicators coletas

            // resumoMapaColetas(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
